
import React from 'react';
import ZNetwork from "./znetwork";
import ZProps from "./zprops";
import {APP} from "./App";
import { AUTH } from './AMCAuth';
import {ROUTER} from "./AMCRouter";
import PleaseStandBy from "./PleaseStandBy";
import ZooErrorFoundPage from "./ZooErrorFoundPage";
import AMCForm from "./AMCForm";

export default class AMCUserResetPassword extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		ZNetwork.get("confirm", this.props.code, (err, payload) => {
			if (err) {
				this.setState({ error: "Invalid link or link expired" });
			} else {
				AUTH.signedIn( payload.user, payload.settings, payload.group );
				this.setState({ found: true });
			}
		});
	}
	onSave(properties) {
		if (properties.password && properties.password === properties.password2) {
			ZNetwork.post("user", "uppwd", { password: properties.password }, (err) => {
				if (!err) {
					APP.setBanner("Awesome. Password updated");
					ROUTER.pushRoute("/" + ZProps.get("user").uri);
				}
			});
		}
	}
	render() {
		let { error, found } = this.state;
		if (!found && !error) {
			return <PleaseStandBy />;
		}
		if (error) {
			return <ZooErrorFoundPage />;
		}
		let fields = [
			{ name: "Password", field: "password", kind: "password", minlen: 8, maxlen: 64, placeholder: "password", required: true },
			{ name: "Confirm", field: "password2", kind: "password", minlen: 8, maxlen: 64, placeholder: "confirm password", required: true },
		]
		let values = {};
		let payload = <AMCForm fields={fields} values={values} onSave={this.onSave.bind(this)} saveButton={ "Save" } />
		return	(
			<div className="AMCUserResetPassword ZooGeneralPage">
				{payload}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/AMCUserResetPassword.js